/** The message an API rejection carries.
 *
 *  The backend answers a refused write with `{ detail: ... }`, which is what the
 *  reviewer needs to read; anything else — a network failure, a thrown Error —
 *  falls back to its own message. Callers show the result as it comes back.
 */
export function apiErrorMessage(reason: unknown): string {
  const detail = (reason as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail != null) return JSON.stringify(detail);
  return reason instanceof Error ? reason.message : String(reason);
}
